import { render, staticRenderFns } from "./medkon_tren_media_konvensional.vue?vue&type=template&id=115cac9d&scoped=true"
import script from "./medkon_tren_media_konvensional.vue?vue&type=script&lang=js"
export * from "./medkon_tren_media_konvensional.vue?vue&type=script&lang=js"
import style0 from "./medkon_tren_media_konvensional.vue?vue&type=style&index=0&id=115cac9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115cac9d",
  null
  
)

export default component.exports